import React from 'react';
import Carousel from '../carousel/carousel';
import { NavLink } from "react-router-dom";
class Mantra_11_A1_Canvas extends React.Component {
    render() {
        return (
            <section className="canvas_section mantra11_canvas setdiv_canvas" id={"canvas_generate_" + this.props.module_name}>
                <div className="m11_canvas_liketo">
                    <span>I like to</span>
                </div>
                <h5 className="m11_canvas_txt1 mt10 mb10">{this.props.btn}</h5>
                <div className="m11_canvas_back2">
                    <p>Because...*<br />
                        {this.props.message}</p>
                </div>
                <h6 className="m11_cans_txt1">{this.props.name}</h6>
            </section>
        )
    }
}

export default Mantra_11_A1_Canvas;